/**
 * Modern confirm dialog for Naturals Reels (replaces window.confirm).
 */
export default function ConfirmModal({
  open,
  title = 'Confirm',
  body,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  busy = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div
      className="tip-modal-backdrop confirm-modal-backdrop"
      role="presentation"
      onClick={busy ? undefined : onCancel}
    >
      <div
        className={`tip-modal confirm-modal${danger ? ' confirm-modal--danger' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <p className="eyebrow">{danger ? 'Please confirm' : 'Confirm'}</p>
        <h2 id="confirm-modal-title" className="tip-modal-title">
          {title}
        </h2>
        {body ? <p className="tip-modal-body">{body}</p> : null}
        <div className="confirm-modal-actions">
          <button
            type="button"
            className={`btn ${danger ? 'btn-danger' : 'btn-primary'} confirm-modal-confirm`}
            disabled={busy}
            onClick={onConfirm}
          >
            {busy ? 'Working…' : confirmLabel}
          </button>
          <button
            type="button"
            className="btn btn-ghost confirm-modal-cancel"
            disabled={busy}
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
